var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-refresh": true,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { refresh: _vm.refreshCertificates },
    },
    [
      _c("template", { slot: "pageContent" }, [
        _c("div", { staticClass: "listPage ml-3 mr-3" }, [
          _c("h1", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.listTitle))]),
          _vm._v(" "),
          _c(
            "section",
            { attrs: { "aria-labelledby": "certificate-list" } },
            [
              _c(
                "h2",
                { staticClass: "sr-only", attrs: { id: "certificate-list" } },
                [_vm._v(_vm._s(_vm.$t("common.security.certificates_list")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-center mb-5" },
                [
                  _c("security-list", {
                    key: _vm.refreshKey,
                    attrs: {
                      typeList: "certificate",
                      spinnerActivated: _vm.activateSpinner,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }